/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'PENSION_PROVIDENT_FUND',
              'MEDICAL',
              'WORK_RELATED_INJURY_ILLNESS_DEATH',
              'UNEMPLOYMENT',
              'MATERNITY',
              'OTHER',
              'NOT_APPLICABLE_WORKER_AND_FACILITY_CONTRIBUTIONS_CANNOT_BE_SEPA',
              'NONE_OF_THE_ABOVE_FACILITY_CALCULATES_ALL_TYPES_OF_LEGALLY_REQU',
              'TOTAL_FACILITY_CONTRIBUTION_AMOUNT_NO_BREAKDOWN_POSSIBLE_IS_IN_',
              'VIETNAM_DOES_THE_FACILITY_SUBMIT_CLAIMS_FOR_SICK_LEAVE_AND_MATE',
              'VIETNAM_DOES_THE_FACILITY_COMPLY_WITH_APPLICABLE_LEGAL_REQUIREM',
              'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_ALL_REQUIREMENTS_RELATE_HEALTH',
              'INDONESIA_DOES_THE_FACILITY_COMPLY_WITH_ALL_REQUIREMENTS_RELATE_SOCIAL',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_fac_social_insurance_contributions_both: valueSchema,
  },
}
